import { FC, Fragment, useEffect, useState } from "react";
import { Container, TabeContainer, TabeCart } from "./style";
import Pagination from "components/particles/pagination/pagination";

import orderIcon from "assets/images/order-white-icon.svg";
import sessionDarkIcon from "assets/images/session-dark-icon.svg";
import orderDarkIcon from "assets/images/order-dark-icon.svg";
import sessionIcon from "assets/images/session-white-icon.svg";
import { useDispatch, useSelector } from "react-redux";

import { setManageStatusActiveButton } from "store/user-slice";
import Button from "components/particles/primary-button";
import { tableData } from "utils/helpers/dummyData";
import NoDataFound from "components/particles/no-data-found";

import view from "assets/images/view-icon.svg";
import { Status } from "containers/home-chefs/view/styled";
import rating from "assets/images/RatingStar.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import { siteRoutes } from "utils/helpers/enums/routes.enums";
import { set, useForm } from "react-hook-form";
import {
  manageStateOrderSearchDTO,
  manageStateSessionSearchDTO,
} from "utils/helpers/models/manageState.dto";
import useActivityManagement from "./useHook";

interface ManageStateProps { }

interface SearchQuery {
  name: string;
  email: string;
  gender: string;
}

const ManageState: FC<ManageStateProps> = () => {
  const { manageStateActiveButton, isLoading } = useSelector(
    (state: any) => state.user
  );
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    reset: formReset,
  } = useForm<manageStateOrderSearchDTO | manageStateSessionSearchDTO>();
  const [sessionData, setSessionData] = useState<any>([]);
  const [orderData, setOrderData] = useState<any>([]);
  const [sessionPaginationState, setSessionPaginationState] = useState<any>();
  const [orderPaginationState, setOrderPaginationState] = useState<any>();
  const [searchParams, setSearchParams] = useSearchParams();
  const [resetTriggered, setResetTriggered] = useState(false);


  console.log(sessionPaginationState);

  const handleViewPage = (orderId: string) => {
    navigate(siteRoutes.manageStatePrint, { state: { orderId } });
  };
  const handleGoToPage = (sessionId: string) => {
    navigate(siteRoutes.homeChefViewDetail, { state: { sessionId } });
  };

  const {
    getOrderDetails,
    sessionDetails,
    getSessionByUserById,
    getOrderByUserById,
  } = useActivityManagement();
  useEffect(() => {
    const tabFromParams = searchParams.get("tab");
    if (tabFromParams === "Order Details" || tabFromParams === "Session Details") {
      dispatch(setManageStatusActiveButton(tabFromParams));
    } else {
      dispatch(setManageStatusActiveButton("Order Details"));
      setSearchParams({ tab: "Order Details" }); // fallback to default tab
    }
  }, [searchParams]);


  useEffect(() => {
    formReset({
      id: "",
      date: "",
      cook: "",
      retailer: "",
      status: "",
    });
  }, [manageStateActiveButton, formReset]);



  const search = (data: manageStateOrderSearchDTO | manageStateSessionSearchDTO) => {
    const query: any = {
      tab: manageStateActiveButton,
      id: data.id || "",
      date: data.date || "",
      status: data.status || "",
      cook: data.cook || "",
      retailer: data.retailer || "",
    };

    setSearchParams(query);

    if (manageStateActiveButton === "Session Details") {
      getSessionByUserById(
        data.id,
        data.date,
        setSessionData,
        data.cook || "",
        data.status || "",
        setSessionPaginationState,
        { offset: 0, limit: 10 } // ✅ Add pagination params
      );
      setSessionPaginationState((prev: any) => ({
        ...prev,
        offset: 0,
      }));
    } else if (manageStateActiveButton === "Order Details") {
      // getOrderByUserById(data.id, data.date, data.retailer, setOrderData);
      getOrderByUserById(
        data.id,
        data.date,
        data.retailer,
        setOrderData,
        setOrderPaginationState, // ✅ Add this
        { offset: 0, limit: 10 }  // ✅ Add pagination params
      );
      setOrderPaginationState((prev: any) => ({
        ...prev,
        offset: 0,
      }));
    }
  };
  // const reset = () => {
  //   formReset({
  //     id: "",
  //     date: "",
  //     cook: "",
  //     retailer: "",
  //     status: "",
  //   });


  //   setSearchParams({ tab: manageStateActiveButton }); // clear filters from URL

  //   const paginationState = { offset: 0, limit: 10 };

  //   if (manageStateActiveButton === "Session Details") {
  //      setSessionPaginationState((prev: any) => ({
  //     ...prev,
  //     offset: 0,
  //   }));
  //     sessionDetails(setSessionData, setSessionPaginationState, paginationState);
  //   } else if (manageStateActiveButton === "Order Details") {
  //      setOrderPaginationState((prev: any) => ({
  //     ...prev,
  //     offset: 0,
  //   }));
  //     getOrderDetails(setOrderData, setOrderPaginationState, paginationState);
  //   }
  // };
  // const reset = () => {
  //   // 1. Reset all filter values
  //   formReset({
  //     id: "",
  //     date: "",
  //     cook: "",
  //     retailer: "",
  //     status: "",
  //   });

  //   // 2. Clear query params
  //   setSearchParams({ tab: manageStateActiveButton });

  //   // 3. Prepare base pagination state
  //   const basePagination = { offset: 0, limit: 10 };

  //   // 4. Reset pagination UI state and fetch API
  //   if (manageStateActiveButton === "Session Details") {
  //     setSessionPaginationState(basePagination);
  //     sessionDetails(setSessionData, setSessionPaginationState, basePagination);
  //   } else if (manageStateActiveButton === "Order Details") {
  //     setOrderPaginationState(basePagination);
  //     getOrderDetails(setOrderData, setOrderPaginationState, basePagination);
  //   }
  // };

  const reset = () => {
    // 1. Reset all filter values
    formReset({
      id: "",
      date: "",
      cook: "",
      retailer: "",
      status: "",
    });

    // 2. Clear query params
    setSearchParams({ tab: manageStateActiveButton });

    // 3. Prepare base pagination state with all necessary properties
    const basePagination = {
      offset: 0,
      limit: 10,
      currentPage: 1, // Add this if your Pagination component tracks currentPage
      totalRecords: 0  // Reset total records
    };

    // 4. Reset pagination UI state and fetch API
    if (manageStateActiveButton === "Session Details") {
      // Reset pagination state first
      setSessionPaginationState(basePagination);
      // Then fetch data
      sessionDetails(setSessionData, setSessionPaginationState, basePagination);
    } else if (manageStateActiveButton === "Order Details") {
      // Reset pagination state first
      setOrderPaginationState(basePagination);
      // Then fetch data
      getOrderDetails(setOrderData, setOrderPaginationState, basePagination);
    }
  };

  // Alternative approach - using useEffect to ensure state is updated before API call
  const resetAlternative = () => {
    // 1. Reset all filter values
    formReset({
      id: "",
      date: "",
      cook: "",
      retailer: "",
      status: "",
    });

    // 2. Clear query params
    setSearchParams({ tab: manageStateActiveButton });

    // 3. Prepare base pagination state
    const basePagination = {
      offset: 0,
      limit: 10,
      currentPage: 1,
      totalRecords: 0
    };

    // 4. Set pagination state and use useEffect to handle API call
    if (manageStateActiveButton === "Session Details") {
      setSessionPaginationState(basePagination);
      setSessionData([]); // Clear current data
    } else if (manageStateActiveButton === "Order Details") {
      setOrderPaginationState(basePagination);
      setOrderData([]); // Clear current data
    }

    // Use a flag to trigger API call in useEffect
    setResetTriggered(true); // You'll need to add this state
  };

  // Add this useEffect to handle reset API calls
  useEffect(() => {
    if (resetTriggered) {
      const basePagination = { offset: 0, limit: 10 };

      if (manageStateActiveButton === "Session Details") {
        sessionDetails(setSessionData, setSessionPaginationState, basePagination);
      } else if (manageStateActiveButton === "Order Details") {
        getOrderDetails(setOrderData, setOrderPaginationState, basePagination);
      }

      setResetTriggered(false); // Reset the flag
    }
  }, [resetTriggered, manageStateActiveButton]);

  const limit = 10;
  function fetchNextRecords(offset: number) {
    const id = searchParams.get("id") || "";
    const date = searchParams.get("date") || "";
    const cook = searchParams.get("cook") || "";
    const retailer = searchParams.get("retailer") || "";
    const status = searchParams.get("status") || "";

    const paginationState = { offset, limit };

    const hasFilters = id || date || cook || retailer || status;

    if (manageStateActiveButton === "Session Details") {
      setSessionPaginationState((prev: any) => ({
        ...prev,
        offset,
      }));

      if (hasFilters) {
        getSessionByUserById(id, date, setSessionData, cook, status, setSessionPaginationState, paginationState);
      } else {
        sessionDetails(setSessionData, setSessionPaginationState, paginationState);
      }

    } else if (manageStateActiveButton === "Order Details") {
      setOrderPaginationState((prev: any) => ({
        ...prev,
        offset,
      }));

      if (hasFilters) {
        getOrderByUserById(id, date, retailer, setOrderData, setOrderPaginationState, paginationState);
      } else {
        getOrderDetails(setOrderData, setOrderPaginationState, paginationState);
      }
    }

    const toTopElement = document.getElementById("toTop");
    if (toTopElement) {
      toTopElement.scrollIntoView({ behavior: "smooth" });
    } else {
      window.scrollTo(0, 0);
    }
  }
  // function fetchNextRecords(offset: number) {
  //   const paginationState = { offset, limit: 10 };
  //   if (manageStateActiveButton === "Session Details") {
  //     setSessionPaginationState((prevState: any) => ({
  //       ...prevState,
  //       offset: offset,
  //     }));
  //     sessionDetails(
  //       setSessionData,
  //       setSessionPaginationState,
  //       paginationState
  //     );
  //   } else if (manageStateActiveButton === "Order Details") {
  //     setOrderPaginationState((prevState: any) => ({
  //       ...prevState,
  //       offset: offset,
  //     }));
  //     getOrderDetails(setOrderData, setOrderPaginationState, paginationState);
  //   }
  //   const toTopElement = document.getElementById("toTop");
  //   if (toTopElement) {
  //     toTopElement.scrollIntoView({ behavior: "smooth" });
  //   } else {
  //     window.scrollTo(0, 0);
  //   }
  // }
  // useEffect(() => {
  //   dispatch(setManageStatusActiveButton("Order Details"));
  // }, []);

  ////////////////////////////////////////////////////////////////
  useEffect(() => {
    const id = searchParams.get("id") || "";
    const date = searchParams.get("date") || "";
    const cook = searchParams.get("cook") || "";
    const retailer = searchParams.get("retailer") || "";
    const status = searchParams.get("status") || "";

    const paginationState = { offset: 0, limit: 10 };

    formReset({ id, date, cook, retailer, status });

    const hasFilters = id || date || cook || retailer || status;

    if (manageStateActiveButton === "Session Details") {
      if (hasFilters) {
        getSessionByUserById(id, date, setSessionData, cook, status);
      } else {
        sessionDetails(setSessionData, setSessionPaginationState, paginationState);
      }
    } else if (manageStateActiveButton === "Order Details") {
      if (hasFilters) {
        getOrderByUserById(id, date, retailer, setOrderData);
      } else {
        getOrderDetails(setOrderData, setOrderPaginationState, paginationState);
      }
    }
  }, [manageStateActiveButton]);


  return (
    <Container id="toTop">
      <div className="title">
        <h1>Activities List</h1>
      </div>

      <TabeContainer>
        <TabeCart
          active={manageStateActiveButton === "Order Details"}
          onClick={() => {
            setSearchParams({ tab: "Order Details" });
            dispatch(setManageStatusActiveButton("Order Details"));
          }}
        >
          <div className="categories-tab-img">
            <img
              src={
                manageStateActiveButton === "Order Details"
                  ? orderIcon
                  : orderDarkIcon
              }
              alt="img"
            />
          </div>
          <h1>Order Details</h1>
        </TabeCart>
        <TabeCart
          active={manageStateActiveButton === "Session Details"}
          onClick={() => {
            setSearchParams({ tab: "Session Details" });
            dispatch(setManageStatusActiveButton("Session Details"));
          }}
        >
          <div className="categories-tab-img">
            <img
              src={
                manageStateActiveButton === "Session Details"
                  ? sessionIcon
                  : sessionDarkIcon
              }
              alt="img"
            />
          </div>
          <h1>Session Details</h1>
        </TabeCart>
      </TabeContainer>

      <div className="search-container">
        <div className="input-fields">
          {manageStateActiveButton === "Order Details" ? (
            <>
              <input
                type="text"
                placeholder="Search by Order id"
                {...register("id")}
              />
              <div className="custom-date-input-container">
                <input
                  type="date"
                  className="custom-date-input"
                  placeholder="Search by Date"
                  {...register("date")}
                />
              </div>
              <input
                type="text"
                placeholder="Search By Retailer"
                {...register("retailer")}
              />
            </>
          ) : (
            <>
              <input
                type="text"
                placeholder="Search by Session id"
                {...register("id")}
              />
              <div className="custom-date-input-container">
                <input
                  type="date"
                  className="custom-date-input"
                  placeholder="Search by Date"
                  {...register("date")}
                />
              </div>
              <input
                type="text"
                placeholder="Search By Home Cook"
                {...register("cook")}
              />
              <select id="satus" {...register("status")}>
                <option value="">Status</option>
                {/* {options.slice(1).map((item, index) => (
                  <option value={item} key={index}>
                    {item}
                  </option>
                ))} */}
                <option value="incoming">Incoming</option>
                <option value="readyToPay">Pending Payment</option>
                <option value="paid">Paid</option>
                <option value="active">Active</option>
                <option value="completed">Completed</option>
                <option value="rejected">Rejected</option>
                <option value="expired">Expired</option>
              </select>
            </>
          )}
        </div>
        <div className="button-fields">
          <Button
            title="Search"
            width="16rem"
            fill="true"
            onclick={handleSubmit(search)}
          />
          <Button
            title="Reset"
            width="16rem"
            fill="true"
            backgroundcolor="var(--reset-button)"
            onclick={handleSubmit(reset)}
          />
        </div>
      </div>
      <div className="data-table">
        <table>
          <thead>
            <tr>
              <th className="th">
                {manageStateActiveButton === "Order Details"
                  ? "Order ID"
                  : "Session ID"}
              </th>
              <th scope="col">Date</th>
              <th scope="col">Placed by</th>
              <th scope="col">
                {manageStateActiveButton === "Order Details"
                  ? "Retailer"
                  : "Home Cook"}
              </th>
              <th className="th">Amount</th>
              {/* <th className="th">
                {manageStateActiveButton === "Order Details"
                  ? "Items"
                  : "Duration"}
              </th> */}
              {manageStateActiveButton === "Order Details" ? (
                ""
              ) : (
                <th className="th">Rating</th>
              )}
              <th className="th">
                {manageStateActiveButton === "Order Details"
                  ? "Actions"
                  : "Status"}
              </th>
              <th className="th">
                {manageStateActiveButton === "Order Details"
                  ? ""
                  : "Actions"}
              </th>
            </tr>
          </thead>
          <tbody>
            {(manageStateActiveButton === "Order Details"
              ? orderData
              : sessionData
            )?.length > 0 ? (
              (manageStateActiveButton === "Order Details"
                ? orderData
                : sessionData
              ).map((item: any, index: number) => (
                <tr key={index}>
                  <td className="th">
                    {manageStateActiveButton === "Order Details"
                      ? item.generatedOrderId
                      : item.sessionId}
                  </td>
                  <td>
                    {new Date(
                      manageStateActiveButton === "Order Details"
                        ? item.createdAt
                        : item.sessionDetails.placedOn
                    ).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "2-digit",
                      day: "2-digit",
                    })}
                  </td>

                  <td>
                    {manageStateActiveButton === "Order Details"
                      ? item.customerName
                      : item?.user?.userName}
                  </td>
                  <td>
                    {manageStateActiveButton === "Order Details"
                      ? `${item.retailerInfo.firstName} ${item.retailerInfo.lastName}`
                      : item.homeCook?.homeCookName || "N/A"}
                  </td>

                  <td className="th">
                    {manageStateActiveButton === "Order Details"
                      ? "$" + Math.round(item.totalAmount)
                      : "$" + item.sessionDetails.sessionAmount}
                  </td>
                  {/* <td className="th">
                    {manageStateActiveButton === "Order Details"
                      ? item.totalOrderedItems
                      : item.sessionDetails.sessionDuration}
                  </td> */}
                  {manageStateActiveButton === "Session Details" && (
                    <td className="th">
                      {item.sessionDetails.sessionRating || "-"}
                    </td>
                  )}
                  <td className="actions th">
                    {manageStateActiveButton === "Order Details" ? (
                      <div
                        className="view-container"
                        onClick={() => handleViewPage(item.generatedOrderId)}
                      >
                        <img src={view} alt="img" />
                      </div>
                    ) : (
                      <Status active={item.status}>
                        {item.sessionDetails?.sessionStatus
                          ? item.sessionDetails.sessionStatus
                            .charAt(0)
                            .toUpperCase() +
                          item.sessionDetails.sessionStatus.slice(1)
                          : "N/A"}
                      </Status>
                    )}
                  </td>

                  <td className="actions th">
                    {manageStateActiveButton === "Order Details" ? (
                      <>
                      </>
                    ) : (

                      <div
                        className="view-container"
                        onClick={() => handleGoToPage(item.sessionId)}
                      >
                        <img src={view} alt="img" />
                      </div>

                    )}
                  </td>
                </tr>
              ))
            ) : (
              <NoDataFound isShow={!isLoading} />
            )}
          </tbody>
        </table>
      </div>
      <Fragment>
        {/* <Pagination
          totalRecords={
            manageStateActiveButton === "Order Details"
              ? orderPaginationState?.totalOrders
              : sessionPaginationState?.totalSessions || 0
          }
          perPage={limit}
          handleFetchNextRecords={fetchNextRecords}
        /> */}
        {/* <Pagination
          totalRecords={
            manageStateActiveButton === "Order Details"
              ? orderPaginationState?.totalOrders || 0
              : sessionPaginationState?.totalSessions || 0
          }
          perPage={limit}
          handleFetchNextRecords={fetchNextRecords}
        /> */}
        <Pagination
          totalRecords={
            manageStateActiveButton === "Order Details"
              ? orderPaginationState?.totalOrders || 0
              : sessionPaginationState?.totalSessions || 0
          }
          perPage={limit}
          currentPage={
            manageStateActiveButton === "Order Details"
              ? (orderPaginationState?.offset || 0) / limit + 1
              : (sessionPaginationState?.offset || 0) / limit + 1
          }
          handleFetchNextRecords={fetchNextRecords}
        />

      </Fragment>
    </Container>
  );
};

export default ManageState;